var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreatedDate = function SvgCreatedDate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.503 3.001v3.001M16.507 3.001v3.001"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.008,
    height: 16.507,
    x: 3.001,
    y: 4.502,
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    rx: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M3.001 9.504H21.01M12.505 13.006v5.002M9.754 15.507h5.502"
  })));
};
export { SvgCreatedDate as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYmIxODY0ZjgxMjg4OTEyZTdlYzMzYmIwYWI1ZGMzOTMuc3ZnIjs=";